<template>
    <div class="pagination">
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSize" :page-size="rows" layout=" sizes, jumper,slot, prev, next" :total="total">
            <button type="button" class="btn-prev" @click="jumpFirstPage" :disabled="isFirstPage">
                <span class="iconfont icon-diyige"></span>
            </button>
        </el-pagination>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSize" :page-size="rows" layout="slot,total" :total="total">
            <button type="button" class="btn-prev" @click="jumpLastPage" :disabled="isLastPage">
                <span class="iconfont icon-zuihouyige"></span>
            </button>
        </el-pagination> -->
        <div class="page_sizes">
            <el-select v-model="currentRows" placeholder="请选择" @change="handleSizeChange">
                <el-option v-for="(item) in pageSize" :key="item" :label="item + '行/页'" :value="item">
                </el-option>
            </el-select>
        </div>
        <div class="page_page">
            <div>第</div>
            <el-input type="number" min="1" :max="totalPages" v-model.number="currentPage" @keyup.enter.native.stop="jumpPage"></el-input>
            <div>页/共{{ totalPages }}页</div>
        </div>
        <div class="page_next">
            <el-button :disabled="isFirstPage" @click="handleCurrentChange(1)" size="mini"> <span style="font-size: 12px;" class="iconfont icon-diyige"></span></el-button>
            <el-button :disabled="isFirstPage" size="mini" icon="el-icon-back" @click="goPreviousPage">
            </el-button>
            <el-button :disabled="isLastPage" size="mini" icon="el-icon-right" @click="goNextPage">
            </el-button>
            <el-button :disabled="isLastPage" @click="handleCurrentChange(totalPages)" size="mini">
                <span style="font-size: 12px;" class="iconfont icon-zuihouyige"></span>
            </el-button>
        </div>
        <div class="page_total">共{{ total }}行</div>
    </div>
</template>
  <script>
export default {
    name: "vPagination",
    props: {
        page: {
            type: Number || String,
            default: () => {
                return 1
            }
        },
        rows: {
            type: Number || String,
            default: () => {
                return 30
            }
        },
        total: {
            type: Number || String,
            default: () => {
                return 0
            }
        },
        pageSize: {
            type: Array,
            default: () => {
                return [30,50, 100, 200, 300, 400, 500, 1000, 2000]
            }
        },
    },
    data() {
        return {
            currentPage: 1,
            currentRows: 30,
        }
    },
    watch: {
        page: {
            immediate: true,
            handler(val) {
                this.currentPage = val === '' || val == null ? 1 : Number(val);
            },
        },
        rows: {
            immediate: true,
            handler(val) {
                this.currentRows = val === '' || val == null ? 30 : Number(val);
            },
        },
    },
    computed: {
        totalPages() {
            const pages = Math.ceil(Number(this.total) / Number(this.currentRows || this.rows || 1));
            return pages > 0 ? pages : 0;
        },
        isFirstPage() {
            return Number(this.page) <= 1;
        },
        isLastPage() {
            return this.totalPages === 0 || Number(this.page) >= this.totalPages;
        },
    },
    mounted() {
        this.bindKeyPageListener();
    },
    beforeDestroy() {
        this.unbindKeyPageListener();
    },
    deactivated() {
        // keep-alive 缓存退出时也关闭监听
        this.unbindKeyPageListener();
    },
    activated() {
        this.bindKeyPageListener();
    },
    methods: {
        bindKeyPageListener() {
            if (this._keyPageBound) return;
            this._onKeyPage = this.onKeyPage.bind(this);
            window.addEventListener('keydown', this._onKeyPage);
            this._keyPageBound = true;
        },
        unbindKeyPageListener() {
            if (!this._keyPageBound || !this._onKeyPage) return;
            window.removeEventListener('keydown', this._onKeyPage);
            this._onKeyPage = null;
            this._keyPageBound = false;
        },
        // 左右键翻页：← 上一页，→ 下一页
        onKeyPage(e) {
            const key = e.key || e.code;
            if (key !== 'ArrowLeft' && key !== 'ArrowRight' && e.keyCode !== 37 && e.keyCode !== 39) {
                return;
            }
            // 输入框/下拉中输入时不拦截
            const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
            if (tag === 'input' || tag === 'textarea' || tag === 'select' || (e.target && e.target.isContentEditable)) {
                return;
            }
            if (key === 'ArrowLeft' || e.keyCode === 37) {
                e.preventDefault();
                this.goPreviousPage();
            } else if (key === 'ArrowRight' || e.keyCode === 39) {
                e.preventDefault();
                this.goNextPage();
            }
        },
        jumpPage() {
            let val = this.currentPage;
            if (val === '' || val == null) val = 1;
            if (val < 1) val = 1;
            if (this.totalPages > 0 && val > this.totalPages) val = this.totalPages;
            this.currentPage = val;
            this.handleCurrentChange(val);
        },
        goNextPage() {
            if (this.isLastPage) return;
            this.handleCurrentChange(Number(this.page) + 1);
        },
        goPreviousPage() {
            if (this.isFirstPage) return;
            this.handleCurrentChange(Number(this.page) - 1);
        },
        handleSizeChange(val) {
            this.$emit('setDataPageSize', val);
        },
        handleCurrentChange(val) {
            if (val === '' || val == null) val = 1;
            this.$emit('setDataPageNumber', val);
        },
        jumpFirstPage() {
            this.handleCurrentChange(1);
        },
        jumpLastPage() {
            this.handleCurrentChange(this.totalPages);
        },
    },
};
  </script>
  <style scoped>
.pagination {
    /* padding-top: 6px; */
    /* border: 1px solid #c0eae7; */
    border-top: 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 4px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    color: #606266;
    font-size: 14px;
}
.pagination .page_sizes {
    width: 100px;
}
.pagination .page_page {
    display: flex;

    line-height: 28px;
    /* width: 150px;
    justify-content: space-around; */
    /* letter-spacing:2px; */
    margin: 0 10px;
}
.pagination .page_page .el-input {
    width: 40px;
    margin: 0 4px;
}
.pagination .page_page ::v-deep .el-input__inner {
    width: 40px;
    padding: 0;
    text-align: center;
}

.pagination .page_next {
    font-size: 14px;
    color: #c0c4cc;
    display: inline-flex;
    width: 150px;
    justify-content: space-around;
    line-height: 14px;
}
.pagination .page_next span {
    font-size: 13px;
}
.pagination .page_total {
    margin-left: 10px;
    margin-right: 50px;
}

.enable {
    color: #000;
}
.enable:hover {
    color: #409eff;
    cursor: pointer;
}

.not_enable {
    /* color:red */
}

/* ::v-deep .el-pagination__jump {
    margin-left: 0;
}
::v-deep .btn-prev {
    padding-right: 0 !important;
    padding-left: 0 !important;
}
::v-deep .btn-next {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
::v-deep .el-pagination {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
::v-deep .el-pagination button {
    min-width: 26px;
}
::v-deep .el-pagination__jump .el-pagination__editor {
    width: 36px;
}
::v-deep .el-pager .number {
} */
</style>
  